// Vue
import { computed, ComputedRef } from 'vue'

// State
import {getAutocompleteState} from '../state/autocompleteState'

const stationsResults: ComputedRef<number> = computed(() => {
    const autocompleteState = getAutocompleteState()
    const stationLengths = autocompleteState.state.stations.map((station) => {
        return station?.items?.length
    })
    return stationLengths.filter((item) => item).length
})
export default stationsResults
